var map = {
	"./blog-1.jpg": 255,
	"./blog-2.jpg": 256,
	"./blog-five1.jpg": 257,
	"./blog-five2.jpg": 258,
	"./blog-five3.jpg": 259,
	"./blog-standard-1.jpg": 53,
	"./blog-standard-2.jpg": 69,
	"./blog-standard-3.jpg": 70,
	"./call-action-widget.jpg": 260,
	"./comment-author-1.jpg": 71,
	"./comment-author-2.jpg": 72,
	"./comment-author-3.jpg": 73,
	"./footer-widget-1.jpg": 261,
	"./footer-widget-2.jpg": 262,
	"./hd.jpg": 263,
	"./iit.jpg": 264,
	"./iit.png": 265,
	"./navic-chip.jpg": 266,
	"./navic-clock.jpg": 267,
	"./news-1.jpg": 268,
	"./news-10.jpg": 269,
	"./news-11.jpg": 270,
	"./news-12.jpg": 271,
	"./news-13.jpg": 272,
	"./news-14.png": 273,
	"./news-15.png": 274,
	"./news-16.jpeg": 275,
	"./news-17.jpeg": 276,
	"./news-18.jpeg": 277,
	"./news-19.jpg": 278,
	"./news-2.jpg": 279,
	"./news-20.jpeg": 280,
	"./news-3.jpg": 281,
	"./news-4.jpg": 282,
	"./news-5.jpg": 283,
	"./news-6.jpg": 284,
	"./news-7.jpg": 285,
	"./news-8.jpg": 286,
	"./news-9.jpg": 287,
	"./news-author-1.jpg": 288,
	"./news-author-2.jpg": 289,
	"./news-author-3.jpg": 290,
	"./news-bg-two.jpg": 291,
	"./news-bg.jpg": 292,
	"./news-six1.jpg": 293,
	"./news-six2.jpg": 294,
	"./news-six3.jpg": 295,
	"./news-widget-1.jpg": 54,
	"./news-widget-2.jpg": 55,
	"./news-widget-3.jpg": 56,
	"./news1.jpg": 296,
	"./news2.jpg": 297,
	"./news3.jpg": 298,
	"./rit.png": 299,
	"./tele.png": 300
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 254;